import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

api.interceptors.request.use((config) => {
  if (sessionStorage.getItem("client_demo") === "1") config.headers["X-Demo-Mode"] = "1";
  return config;
});

export default api;

const sleep = (ms) => new Promise((r) => setTimeout(r, ms));

const jobError = (msg) => {
  const err = new Error(msg);
  err.response = { data: { detail: msg } };
  return err;
};

export async function pollModuleJob(assetId, moduleKey, { intervalMs = 4000, timeoutMs = 900000 } = {}) {
  const deadline = Date.now() + timeoutMs;
  let misses = 0;
  while (Date.now() < deadline) {
    await sleep(intervalMs);
    let r;
    try {
      r = await api.get(`/assets/${assetId}/modules/${moduleKey}/status`);
      misses = 0;
    } catch {
      if (++misses >= 8) throw jobError("Lost connection while generating — please refresh and retry");
      continue;
    }
    const s = r.data?.status;
    if (s === "done") return { data: r.data.output || {} };
    if (s === "cancelled") throw jobError("Generation was stopped");
    if (s === "error" || s === "idle") throw jobError(r.data?.error || "Generation failed — please retry");
  }
  throw jobError("Generation is taking longer than expected — please retry in a minute");
}

export async function generateModule(assetId, moduleKey) {
  await api.post(`/assets/${assetId}/modules/${moduleKey}`);
  return pollModuleJob(assetId, moduleKey);
}

export async function generateExecutiveReport(assetId, override = false) {
  await api.post(`/assets/${assetId}/report/executive${override ? "?override=true" : ""}`, {}, { timeout: 110000 });
  return pollModuleJob(assetId, "executive_report");
}
